import React from "react";
import AuthForm from "../AuthForm/AuthForm";

const SignUpUser = () => {

  return (

    <AuthForm
      formType="signup"
      onSubmit={(payload) => {
        console.log("Sign up payload:", payload);
        // Dispatch sign-up action here
      }}
    />

  );
};

export default SignUpUser;

